import React, { useEffect, useState } from 'react';
import Loading from '../Loading';
import { useNavigate, useParams } from 'react-router';
import { useForm } from 'react-hook-form';
import { ReactComponent as TargetUndo } from '../../assets/svg/undoTarget.svg';
import { ReactComponent as Settings } from '../../assets/svg/settings.svg';
import { ReactComponent as Save } from '../../assets/svg/Save.svg';
import '../../styles/modals/StudentInfoModal.css';
import ImageComponent from '../ImageComponent';
import { createUpdateSolutionTopic, deleteSolutionTopicById, getLocales, getSolutionCategories, getSolutionTopicById } from '../../server/server';
import CategoriesDropDown from '../courses/CategoriesDropDown';
import { notify } from '../../utils/util';
import { fileSystemUrl } from '../../server/connections';
import ListOfParagraphs from './ListOfParagraphs';
import ListOfSolutions from './ListOfSolutions';
import ExtraSuggestion from './ExtraSuggestion';
import ConfirmationModal from '../modals/ConfirmationModal';
import TopicPreviewModal from './preview/TopicPreviewModal';
import ListOfQuickTips from './ListOfQuickTips';
import ListOfQuotes from './ListOfQuotes';

function SingleSolutionScreen() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [isParent, setIsParent] = useState(window.location.pathname.includes('parent'));
	const [hoveredButton, setHoveredButton] = useState(false);
	const [solution, setSolution] = useState<any>(null);
	const [loading, setLoading] = useState(false);
	const [processing, setProcessing] = useState(false);
	const [image, setImage] = useState<string | undefined>(undefined);
	const [imageId, setImageId] = useState('');
	const [locales, setLocales] = useState([]);
	const [locale, setLocale] = useState('Select');
	const [quotes, setQuotes] = useState(['', '', '']);
	const [solutions, setSolutions] = useState([]);
	const [categories, setCategories] = useState([]);
	const [category, setCategory] = useState('Select');
	const [quotesTextError, setQuotesTextError] = useState(false);
	const [imageIdError, setImageIdError] = useState(false);
	const [selectedSolution, setSelectedSolution] = useState<any>(null);
	const [deleteModalOpen, setDeleteModalOpen] = useState(false);
	const [showPreview, setShowPreview] = useState(false);
	const [tipIds, setTipIds] = useState<any>([]);

	const { register, handleSubmit, watch, reset, formState, getValues, setValue, control } = useForm({
		defaultValues: {
			title: '',
			localeId: '',
			categoryId: '',
			percentageOfShare: 0,
		},
	});
	const { isDirty, isValid, errors } = formState;

	useEffect(() => {
		loadLocales();
		loadCategories();
	}, []);

	useEffect(() => {
		if (id && id !== 'new') loadSolution(id);
	}, [id]);

	useEffect(() => {
		if (!!solution?.id) {
			setValue('title', solution?.title);
			setValue('categoryId', solution.category?.id);
			setCategory(solution.category?.name ?? 'Select');
			setValue('localeId', solution.locale?.id);
			setLocale(solution.locale?.name ?? 'Select');
			setValue('percentageOfShare', solution?.percentageOfShare);
			//setTipIds(solution.tips ?? []);
			setQuotes(solution.quotes ?? []);
			setSolutions(solution.solutions ?? []);
		}
		if (!!solution?.image) {
			const imageUrl = fileSystemUrl + '/' + solution.image?.url;
			setImage(imageUrl);
			setImageId(solution?.image?.id);
		}
	}, [solution]);

	const loadSolution = async (id: string) => {
		setLoading(true);
		const resp = await getSolutionTopicById(id);
		if (resp.status == 200) {
			setSolution(resp.data);
			setLoading(false);
		} else {
			setLoading(false);
		}
	};

	const loadLocales = async () => {
		const resp = await getLocales();
		if (resp.status === 200) {
			setLocales(resp.data);
		}
	};

	const validate = () => {
		console.log('here', quotes);
		let valid = true;
		quotes.forEach((element: any) => {
			console.log('element ', element);
			if (element === '') {
				setQuotesTextError(true);
				valid = false;
				return;
			}
		});
		// if (!imageId) {
		// 	setImageIdError(true);
		// 	valid = false;
		// }
		return valid;
	};

	const reloadTopic = () => {
		if (!!id) loadSolution(id);
	};

	const onSubmit = async () => {
		console.log(' values ', getValues());
		if (!validate()) return;
		if (solution === null) {
			createSolutionTopic();
		} else {
			updateSolutionTopic();
		}
	};

	const createSolutionTopic = async () => {
		setProcessing(true);
		let newTopic: any = getValues();
		newTopic.percentageOfShare = isNaN(parseInt(newTopic.percentageOfShare)) ? 0 : parseInt(newTopic.percentageOfShare);
		// newTopic.imageId = imageId ?? null;
		newTopic.tipIds = tipIds;
		newTopic.quotes = quotes;
		delete newTopic.imageId;
		newTopic.imageId = !!imageId ? imageId : null;

		const resp = await createUpdateSolutionTopic(newTopic);
		if (resp.status === 201) {
			if (isParent) navigate(`/parent-solutions/${resp.data?.id}`);
			else navigate(`/solutions/${resp.data?.id}`);
			notify('Topic is created!');
			setProcessing(false);
		} else {
			notify('Topic is not created!');
			setProcessing(false);
		}
	};
	const updateSolutionTopic = async () => {
		setProcessing(true);
		let newTopic: any = getValues();
		newTopic.id = solution.id;
		newTopic.percentageOfShare = isNaN(parseInt(newTopic.percentageOfShare)) ? 0 : parseInt(newTopic.percentageOfShare);
		newTopic.imageId = !!imageId ? imageId : null;
		newTopic.tipIds = tipIds;
		newTopic.quotes = quotes;

		const resp = await createUpdateSolutionTopic(newTopic);
		if (resp.status === 201) {
			reloadTopic();
			notify('Topic is updated!');
			setProcessing(false);
		} else {
			setProcessing(false);
			notify('Topic is not updated!');
		}
	};

	const loadCategories = async () => {
		const resp = await getSolutionCategories(isParent ? 'PARENT' : 'CHILD');
		if (resp.status === 200) {
			setCategories(resp.data);
		}
	};

	const setSelectedCategoryId = (item: any) => {
		setValue('categoryId', item?.id, { shouldValidate: true });
		setCategory(!!item?.name ? item.name : 'Select');
	};

	const setSelectedLocaleId = (item: any) => {
		setValue('localeId', item?.id, { shouldValidate: true });
		setLocale(!!item?.name ? item.name : 'Select');
	};

	const setDeleteJournalModal = (solution: any) => {
		setSelectedSolution(solution);
		setDeleteModalOpen(true);
	};

	const closeDeleteModal = () => {
		setSelectedSolution(null);
		setDeleteModalOpen(false);
	};

	const changeVisibility = () => {};

	const deleteSolution = async () => {
		const resp = await deleteSolutionTopicById(selectedSolution?.id);
		if (resp.status === 200) {
			navigate(-1);
			notify('The topic has been successfully deleted!');
		} else {
			notify('The topic has not been deleted!');
		}
	};

	const openShowPreview = () => {
		setShowPreview(true);
	};

	const closeShowPreview = () => {
		setShowPreview(false);
	};

	return (
		<div className='flex h-full flex-col items-center overflow-y-auto bg-[#ECEBF8] py-[40px]'>
			<div className=' w-full max-w-[1200px] px-[10px] '>
				<form onSubmit={handleSubmit(onSubmit)} className='w-full  bg-white flex flex-col px-[40px] py-[30px] rounded-[10px]'>
					{loading && (
						<div className='w-full flex flex-row items-center justify-center min-h-[600px]'>
							<Loading size={70} primaryColor='#5E639B' stroke={3} />
						</div>
					)}
					{!loading && (
						<div className='flex flex-col gap-5'>
							<div className='flex flex-row w-full items-start gap-5'>
								<div className='w-[calc(100%-400px)]'>
									<div className='flex flex-row items-center gap-5'>
										<div className=' flex cursor-pointer  items-center justify-center bg-primaryViolet hover:bg-darkViolet  min-w-[56px] w-[56px] h-[56px] rounded-full' onClick={() => navigate(-1)} onMouseEnter={() => setHoveredButton(true)} onMouseLeave={() => setHoveredButton(false)}>
											<TargetUndo fill={hoveredButton ? '#FDDF6D' : '#FFFFFF'} />
										</div>
										<div className='font-semibold text-primaryViolet text-[34px] leading-[40px]  ellipsis'>{watch('title')}</div>
									</div>
									<div className='flex flex-row gap-5 mt-3'>
										<ImageComponent image={image} setImage={setImage} imageId={imageId} errorCheck={imageIdError} setImageId={setImageId} />
										<div className='flex flex-col gap-5 flex-1'>
											<div className=''>
												<p className='text-primaryViolet text-[16px] leading-5 font-semibold text-left'>Topic title</p>
												<div className={`border-b  p-2 mt-2 flex flex-row items-center ${errors.title?.type === 'required' ? 'border-b-redError' : 'border-b-deselectPurple'}`}>
													<input className={`w-full text-primaryViolet ${errors.title?.type === 'required' ? 'placeholder:text-redError' : ''}`} placeholder={`Type topic title`} {...register('title', { required: true })} style={{ backgroundColor: 'transparent' }} />
													<p className='text-redError   text-nowrap'>{errors.title?.type === 'required' ? '*This field is required' : ''}</p>
												</div>
											</div>
											<div className=''>
												<p className='text-primaryViolet text-[16px] leading-5 font-semibold text-left'>Percentage of share</p>
												<div className={`border-b  p-2 mt-4 flex flex-row items-center ${!!errors.percentageOfShare?.message ? 'border-b-redError' : 'border-b-deselectPurple'}`}>
													<input
														className={`w-full text-primaryViolet ${!!errors.percentageOfShare?.message ? 'placeholder:text-redError text-redError' : ''}`}
														placeholder={`Type percentage of share`}
														{...register('percentageOfShare', {
															required: '* Field is required!',
															pattern: {
																value: /^[1-9]\d*$/, // Dozvoljava pozitivan ceo broj
																message: 'Must be a positive numeric value!',
															},
														})}
														style={{ backgroundColor: 'transparent' }}
													/>
													<p className='text-redError   text-nowrap'>{errors.percentageOfShare?.message}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<Configuration
									solution={solution}
									category={category}
									categories={categories}
									categoryErrorType={errors.categoryId?.type}
									locale={locale}
									locales={locales}
									localeErrorType={errors.localeId?.type}
									changeVisibilty={changeVisibility}
									register={register}
									setSelectedCategoryId={setSelectedCategoryId}
									setSelectedLocaleId={setSelectedLocaleId}
									setDeleteJournalModal={setDeleteJournalModal}
									openShowPreview={openShowPreview}
								/>
							</div>
							<ListOfQuotes quotes={quotes} quotesTextError={quotesTextError} setQuotes={setQuotes} />
							{/* {<ListOfQuickTips tipIds={tipIds} setTipIds={setTipIds} topicId={solution?.id} reloadTopic={reloadTopic} />} */}
							{!!id && id !== 'new' && <ListOfSolutions solutions={solutions} setSolutions={setSolutions} topicId={solution?.id} reloadTopic={reloadTopic} />}
							<div className='flex flex-row justify-end w-full gap-5'>
								<button className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer  rounded-full bg-primaryViolet  min-h-[60px] button-save-class transition' disabled={processing}>
									{processing ? (
										<Loading primaryColor='#FDDF6D' secondaryColor='#5E639B' size={25} stroke={7} />
									) : (
										<div className='flex flex-row items-center justify-center'>
											<p className='text-[18px]  leading-5 font-semibold mr-3 '>Save</p>
											<Save />
										</div>
									)}
								</button>
							</div>
						</div>
					)}
				</form>
			</div>
			<ConfirmationModal modalIsOpen={deleteModalOpen} closeModal={closeDeleteModal} confirmation={deleteSolution} message={'Do you want to delete this topic?!'} />
			<TopicPreviewModal modalIsOpen={showPreview} closeModal={closeShowPreview} currentTopic={solution} />
		</div>
	);
}

export default SingleSolutionScreen;

const Configuration = ({
	solution,
	category,
	categories,
	locale,
	locales,
	register,
	categoryErrorType,
	localeErrorType,
	changeVisibilty,
	setDeleteJournalModal,
	setSelectedCategoryId,
	setSelectedLocaleId,
	openShowPreview,
}: {
	solution: any;
	category: any;
	categories: any;
	locale: any;
	locales: any;
	register: any;
	categoryErrorType: any;
	localeErrorType: any;
	changeVisibilty: any;
	setDeleteJournalModal: any;
	setSelectedCategoryId: any;
	setSelectedLocaleId: any;
	openShowPreview: any;
}) => {
	return (
		<div className='min-w-[380px] p-[20px]  border rounded-[10px] border-primaryViolet flex flex-col ml-[0px]'>
			<div className='flex flex-row items-center gap-2'>
				<Settings fill={'#FFBA00'} />
				<p className='text-primaryViolet font-bold text-[20px] leading-6'> Configuration</p>
			</div>
			<div className='flex flex-col flex-1 gap-[7px] mt-2'>
				{/* <div className={`flex flex-row items-center cursor-pointer my-2`} onClick={() => {}}>
					<div className='border-[1.5px] border-primaryViolet rounded-full h-[18px] w-[18px] flex items-center justify-center' onClick={() => changeVisibilty()}>
						{solution?.visible && <div className='rounded-full h-[10px] w-[10px] bg-primaryViolet'></div>}
					</div>
					<label className='text-primaryViolet text-[16px] font-medium ml-[13px] cursor-pointer not-selectable'>Topic visible</label>
				</div> */}

				<CategoriesDropDown list={categories} register={register} registerField='categoryId' errors={categoryErrorType} label='Categories' selectedValue={category} setSelectedValue={setSelectedCategoryId} />
				<CategoriesDropDown list={locales} register={register} registerField='localeId' errors={localeErrorType} label='Locales' selectedValue={locale} setSelectedValue={setSelectedLocaleId} />
				{!!solution?.id && (
					<button className='bg-[#ECEBF8] p-[10px] rounded-[10px] cursor-pointer text-primaryViolet font-bold text-[14px] hover:text-brandYellow hover:bg-primaryViolet ease-in-out duration-200 transition-all' onClick={() => openShowPreview(true)} type='button'>
						Show topic preview
					</button>
				)}
				<div className='bg-white border border-redError p-[10px] rounded-[10px] cursor-pointer text-redError font-bold text-[14px] text-center hover:text-white hover:bg-redError ease-in-out duration-200 transition-all' onClick={() => setDeleteJournalModal(solution)}>
					Delete solution
				</div>
			</div>
		</div>
	);
};
